export default "__VITE_ASSET__xxUeS2oC__"